export default [
	{
		title: `Dashboard`,
		path: '/portfolio/dashboard',
		id: 'dashboard',
		permission: 'view-colender-dashboard',
		// parent:'menu_8'
		sidebarIcon: (
			<i
				className='item-icon material-icons-round fa fa-bar-chart  mt-1'
				aria-hidden='true'
			></i>
		),
	},
	{
		// icon: <i className='fa fa-file-text-o' aria-hidden='true'></i>,
		title: 'Search Global LAF/LAN',
		path: '/portfolio/global-search',
		permission: 'search-global-laf-lan',
		// parent:'menu_4',
		id: 'global-search',
		sidebarIcon: (
			<i
				className='item-icon material-icons-round fa fa-globe mt-1'
				aria-hidden='true'
			></i>
		),
	},
	// {
	// 	title: 'Manage Leads',
	// 	path: '/manage-leads',
	// 	id: 'menu_2',
	// sidebarIcon: (
	// 	<i
	// 		className='item-icon material-icons-round fa fa-user-plus  mt-1'
	// 		aria-hidden='true'
	// 	></i>
	// ),
	// 	permission: 'lead-list',
	// 	subChilds: [
	// 		{
	// 			title: 'Manage Leads',
	// 			path: '/manage-leads',
	// 			icon: (
	// 				<i
	// 					className='item-icon material-icons-round fa fa-hand-pointer-o  mt-1'
	// 					aria-hidden='true'
	// 				></i>
	// 			),
	// 			permission: 'lead-list',
	// 		},
	// 		{
	// 			icon: <i className='fa fa-plus-circle' aria-hidden='true'></i>,
	// 			title: 'Add Lead',
	// 			path: '/lead/add',
	// 			permission: 'admin-add-lead',
	// 		},
	// 	],
	// },
	// {
	// 	title: 'Manage Affiliate/DSA',
	// 	path: '/manage-affiliate',
	// 	sidebarIcon: (
	// 		<i
	// 			className='item-icon material-icons-round fa fa-user-plus  mt-1'
	// 			aria-hidden='true'
	// 		></i>
	// 	),
	// 	subChilds: [
	// 		{
	// 			title: 'BH Approval Status',
	// 			path: '/nsm/approval',
	// 			id: 'menu_8',
	// 			icon: (
	// 				<i
	// 					className='item-icon material-icons-round fa fa-hand-pointer-o  mt-1'
	// 					aria-hidden='true'
	// 				></i>
	// 			),
	// 			permission: 'nsm-partner-listing',
	// 		},
	// 		{
	// 			title: 'Manage Affiliate',
	// 			path: '/manage-affiliate',
	// 			icon: (
	// 				<i
	// 					className='item-icon material-icons-round fa fa-hand-pointer-o  mt-1'
	// 					aria-hidden='true'
	// 				></i>
	// 			),
	// 		},
	// 		// {
	// 		// 	title: 'Affiliate Mapping',
	// 		// 	path: '/affiliate-mapping',
	// 		// 	icon: <i className='item-icon material-icons-round fa fa-plus-circle' aria-hidden='true'></i>
	// 		// },
	// 		// {
	// 		// 	title: ' Block/Remove Affiliate',
	// 		// 	path: '/block-affiliate',
	// 		// 	icon: <i className='item-icon material-icons-round fa fa-minus-circle' aria-hidden='true'></i>
	// 		// }
	// 	],
	// 	permission: 'manage_affiliate',
	// },

	// {
	// 	path: '/comission-report',
	// 	title: 'Commission Reports',
	// 	id: 'menu_3',
	// 	sidebarIcon: (
	// 		<i
	// 			className='item-icon material-icons-round fa fa-file-image-o mt-1'
	// 			aria-hidden='true'
	// 		></i>
	// 	),
	// 	permission: 'generate-partner-commission',
	// },
	// {
	// 	path: '#',
	// 	title: 'Partner Onboarding',
	// 	id: 'menu_5',
	// 	permission: 'manage-partner-onboarding',
	// 	sidebarIcon: (
	// 		<i
	// 			className='item-icon material-icons-round fa fa-cog mt-1'
	// 			aria-hidden='true'
	// 		></i>
	// 	),
	// 	subChilds: [
	// 		{
	// 			path: '/partner/onboarding/add',
	// 			title: 'Add Partner',
	// 			icon: <i className='fa fa-plus-circle' aria-hidden='true'></i>,
	// 			permission: 'add_partner',
	// 		},
	// 		{
	// 			path: '/partner/onboarding/status',
	// 			title: 'Onboarding Status',
	// 			icon: <i className='fa fa-plus-circle' aria-hidden='true'></i>,
	// 			permission: 'partner_onboarding_list',
	// 		},
	// 	],
	// },
	{
		title: 'Unassigned Portfolio',
		path: '/portfolio/unassigned',
		permission: 'get-unassigned-lead-list',
		// parent:'menu_4',
		id: 'unassigned',
		sidebarIcon: (
			<i
				className='item-icon material-icons-round fa fa-hand-paper-o mt-1'
				aria-hidden='true'
			></i>
		),
	},
	{
		path: '/portfolio/pending',
		title: 'Sanction Approval',
		id: 'Sanction Approval',
		permission: 'get-pending-lead-list,inprincipal-lead-list,get-decision-lead-list,get-sanctioned-lead-list,sanction-rejected-lead-list',
		sidebarIcon: (
			<i
				className='item-icon material-icons-round fa fa-list  mt-1'
				aria-hidden='true'
			></i>
		),
		subChilds: [
			{
				title: 'Pending',
				path: '/portfolio/pending',
				permission: 'get-pending-lead-list',
				parent: 'Sanction Approval',
			},

			// {
			// 	title: `In-Principal Sanctioned`,
			// 	path: '/portfolio/inprincipal-sanction',
			// 	permission: 'inprincipal-lead-list',
			// 	parent: 'Sanction Approval',
			// },
			{
				title: 'Approved',
				path: '/portfolio/pre-approved',
				permission: 'get-decision-lead-list',
				parent: 'Sanction Approval',
			},
			{
				title: 'Rejected',
				path: '/portfolio/sanction-rejected',
				permission: 'sanction-rejected-lead-list',
				parent: 'Sanction Approval',
			},
			{
				title: 'Sanctioned',
				path: '/portfolio/assigned',
				permission: 'get-sanctioned-lead-list',
				parent: 'Sanction Approval',
			},
		],
	},
	{
		path: '/portfolio/assigned',
		title: 'Disbursal Approval',
		id: 'Disbursal Approval',
		permission: 'get-sanctioned-lead-list,get-disbursal-pending-lead-list,get-disbursal-approved-lead-list,get-disbursal-rejected-lead-list',
		sidebarIcon: (
			<i
				className='item-icon material-icons-round fa fa-thumbs-o-up mt-1'
				aria-hidden='true'
			></i>
		),
		subChilds: [
			{
				title: 'Sanctioned',
				path: '/portfolio/assigned',
				permission: 'get-sanctioned-lead-list',
				parent: 'Disbursal Approval',
			},

			{
				title: 'Disbursal Pending',
				path: '/portfolio/disbursal-pending',
				permission: 'get-disbursal-pending-lead-list',
				parent: 'Disbursal Approval',
			},
			{
				title: 'Disbursal Approved',
				path: '/portfolio/in-disbursal',
				permission: 'get-disbursal-approved-lead-list',
				parent: 'Disbursal Approval',
			},

			{
				title: 'Disbursal Rejected',
				path: '/portfolio/disbursal-rejected',
				permission: 'get-disbursal-rejected-lead-list',
				parent: 'Disbursal Approval',
			},

		],
	},
	{
		// icon: <i className='fa fa-file-text-o' aria-hidden='true'></i>,
		title: 'Disbursed Portfolio',
		path: '/portfolio/disbursal-approved',
		permission: 'get-disbursed-lead-list',
		// parent:'menu_4',
		id: 'Disbursed Portfolio',
		sidebarIcon: (
			<i
				className='item-icon material-icons-round fa fa-thumbs-up mt-1'
				aria-hidden='true'
			></i>
		),
	},
	{
		// icon: <i className='fa fa-file-text-o' aria-hidden='true'></i>,
		title: 'Post Disbursal Case View',
		path: '/portfolio/post-disbursal',
		permission: 'post-disbursal-case-view',
		// parent:'menu_4',
		id: 'Post-Disbursal-Case-View',
		sidebarIcon: (
			<i
				className='item-icon material-icons-round fa fa-pinterest-p mt-1'
				aria-hidden='true'
			></i>
		),
	},
	{
		// icon: <i className='fa fa-file-text-o' aria-hidden='true'></i>,
		title: 'Query Pending',
		path: '/portfolio/query-pending',
		permission: 'get-query-pending-list',
		// parent:'menu_4',
		id: 'query-pending',
		sidebarIcon: (
			<i
				className='item-icon material-icons-round fa fa-quora mt-1'
				aria-hidden='true'
			></i>
		),
	},
	{
		title: `Collections`,
		path: '/portfolio/collections',
		id: 'collections',
		permission: 'view-collections',
		sidebarIcon: (
			<i
				className='item-icon material-icons-round fa fa-inr  mt-1'
				aria-hidden='true'
			></i>
		),
	},
	// {
	// 	path: '#',
	// 	title: 'Settings',
	// 	id: 'menu_41',
	// 	sidebarIcon: (
	// 		<i
	// 			className='item-icon material-icons-round fa fa-cog mt-1'
	// 			aria-hidden='true'
	// 		></i>
	// 	),
	// 	subChilds: [
	// 		{
	// 			path: '/password/change',
	// 			title: 'Change password',
	// 			icon: (
	// 				<i
	// 					className='item-icon material-icons-round fa fa-hand-pointer-o mt-1'
	// 					aria-hidden='true'
	// 				></i>
	// 			),
	// 		},
	// 	],
	// },
	{
		path: '/misreport/query',
		title: 'MIS Reports',
		id: 'mis_report',
		permission: 'mis-reports',
		sidebarIcon: (
			<i
				className='item-icon material-icons-round fa fa-file-text-o  mt-1'
				aria-hidden='true'
			></i>
		),
		subChilds: [
			{
				title: `Query MIS Report`,
				path: '/misreport/query',
				parent: 'mis_report',
				permission: 'query-mis-reports',

			},
			{
				title: 'Documents Availability MIS',
				path: '/misreport/document',
				parent: 'mis_report',
				permission: 'documents-availability-mis',

			},
			{
				title: 'Portfolio  MIS',
				path: '/misreport/consolidate',
				parent: 'mis_report',
				permission: 'consolidate-mis',

			},
			{
				title: 'BRE Report',
				path: '/misreport/bre',
				parent: 'mis_report',
				permission: 'bre-report',

			},
			{
				title: 'Colending MIS',
				path: '/misreport/colending',
				parent: 'mis_report',
				permission: 'colending-mis',

			},
			{
				title: 'UTR Report',
				path: '/misreport/utr',
				parent: 'mis_report',
				permission: 'utr-report',

			},
			{
				title: 'Lender MIS Report',
				path: '/misreport/lender',
				parent: 'mis_report',
				permission: 'lender-mis-report',

			}

		],
	},
	{
		path: '/api-logs',
		title: 'Co-Lending Api Logs',
		id: 'api_logs',
		permission: 'colending-api-logs',
		sidebarIcon: (
			<i
				className='item-icon material-icons-round fa fa-university  mt-1'
				aria-hidden='true'
			></i>
		),
		subChilds: [
			{
				title: 'CBI Api Logs',
				path: '/api-logs/3',
				parent: 'api_logs',
				permission: 'cbi-api-logs',
			},
			{
				title: 'BOB Api Logs',
				path: '/api-logs/4',
				parent: 'api_logs',
				permission: 'bob-api-logs',
			},
			{
				title: 'SBI Api Logs',
				path: '/api-logs/1',
				parent: 'api_logs',
				permission: 'sbi-api-logs',
			},
			{
				title: 'Godrej Api Logs',
				path: '/api-logs/13',
				parent: 'api_logs',
				permission: 'godrej-api-logs',
			},
			{
				title: 'UCO Api Logs',
				path: '/api-logs/15',
				parent: 'api_logs',
				permission: 'uco-api-logs',
			},
			{
				title: 'KVB Api Logs',
				path: '/api-logs/16',
				parent: 'api_logs',
				permission: 'kvb-api-logs',
			},
			{
				title: 'SIDBI Api Logs',
				path: '/api-logs/19',
				parent: 'api_logs',
				permission: 'sidbi-api-logs',
			},
			{
				title: 'Hero Housing Api Logs',
				path: '/api-logs/18',
				parent: 'api_logs',
				permission: 'hero-housing-api-logs',
			},
			{
				title: 'Karnataka Api Logs',
				path: '/api-logs/20',
				parent: 'api_logs',
				permission: 'karnataka-api-logs',
			},
			{
				title: 'BOM Api Logs',
				path: '/api-logs/23',
				parent: 'api_logs',
				permission: 'bom-api-logs',
			},
			{
				title: 'ABCL Api Logs',
				path: '/api-logs/22',
				parent: 'api_logs',
				permission: 'abcl-api-logs',
			},
			{
				title: 'IDBI Api Logs',
				path: '/api-logs/2',
				parent: 'api_logs',
				permission: 'idbi-api-logs',
			}
		],
	},
	{
		path: '/colending-logs',
		title: 'Co-Lending Logs',
		id: 'colending_logs',
		permission: 'colending-logs',
		sidebarIcon: (
			<i
				className='item-icon material-icons-round fa fa-leanpub  mt-1'
				aria-hidden='true'
			></i>
		),
		subChilds: [
			{
				title: 'MAS Logs',
				path: '/colending-logs/8',
				parent: 'colending_logs',
				permission: 'colending-mas-logs',
			},
			{
				title: 'Mahindra Logs',
				path: '/colending-logs/21',
				parent: 'colending_logs',
				permission: 'colending-mahindra-logs',
			},
			{
				title: 'TATA Capital Logs',
				path: '/colending-logs/17',
				parent: 'colending_logs',
				permission: 'colending-tata-logs',
			}
		],
	},
	// {
	// 	title: `Bulk Fundout `,
	// 	path: '/fundout/bulk',
	// 	id: 'bulk_fundout',
	// 	sidebarIcon: (
	// 		<i
	// 			className='item-icon material-icons-round fa fa-cloud-upload  mt-1'
	// 			aria-hidden='true'
	// 		></i>
	// 	),
	// 	// permission: 'view-colender-dashboard',
	// 	// parent:'menu_8'
	// },
	{
		path: '/additional-info-upload',
		title: 'Additional Info Upload',
		id: 'additional_info_upload',
		permission: 'additional-info-upload',
		sidebarIcon: (
			<i
				className='item-icon material-icons-round fa fa-cloud-upload  mt-1'
				aria-hidden='true'
			></i>
		),
		subChilds: [
			{
				title: 'Credit Info Upload',
				path: '/additional-info-upload/credit',
				permission: 'credit-info-upload',
				parent: 'additional_info_upload',
			},
			{
				title: 'Operations Info Upload',
				path: '/additional-info-upload/operations',
				permission: 'operations-info-upload',
				parent: 'additional_info_upload',
			},
			{
				title: 'UTR Info Upload',
				path: '/additional-info-upload/utr',
				permission: 'nbfc-fundout-info-upload',
				parent: 'additional_info_upload',
			},
			{
				title: 'Cersai Info Upload',
				path: '/additional-info-upload/cersai',
				permission: 'cersai-info-upload',
				parent: 'additional_info_upload',
			},
			{
				title: 'Machinery Info Upload',
				path: '/additional-info-upload/machinery',
				permission: 'machinery-info-upload',
				parent: 'additional_info_upload',
			},
			{
				title: 'LAP Info Upload',
				path: '/additional-info-upload/lap',
				permission: 'lap-info-upload',
				parent: 'additional_info_upload',
			},
			{
				title: 'Collateral File Upload',
				path: '/additional-info-upload/collateral',
				permission: 'collateral-info-upload',
				parent: 'additional_info_upload',
			},
		],
	},
	{
		path: '/da',
		title: 'Direct Assignment Portfolio',
		id: 'da',
		permission: 'pool-selection-list,pool-assignment-list,da-decision-list,da-sanctioned-list',
		sidebarIcon: (
			<i
				className='item-icon material-icons-round fa fa-cloud-upload  mt-1'
			></i>
		),
		subChilds: [
			{
				title: 'Pool selection',
				path: '/da/pool-selection-filter',
				permission: 'pool-selection-list',
				parent: 'da',
			},
			{
				title: 'Pool Assignment',
				path: '/da/pool-assignment',
				permission: 'pool-assignment-list',
				parent: 'da',
			},
			{
				title: 'DA Decision Pending',
				path: '/da/decision-pending',
				permission: 'da-decision-list',
				parent: 'da',
			},
			{
				title: 'DA Sanctioned',
				path: '/da/final-list',
				permission: 'da-sanctioned-list',
				parent: 'da',
			},
		],
	},
	{
		title: 'Manage ACL',
		path: '#',
		permission: 'backend-user-list,add-backend-user,role-permission-list,add-role-permission',
		id: 'manage_acl',
		sidebarIcon: (
			<i
				className='item-icon material-icons-round fa fa-users  mt-1'
				aria-hidden='true'></i>
		),
		subChilds: [
			{
				path: '/admin/roles',
				title: 'Manage Role',
				parent: 'manage_acl',
				permission: 'role-permission-list,update-role-permission,view-role-permissions',
			},
			{
				path: '/admin/role/add',
				title: 'Add Role',
				parent: 'manage_acl',
				permission: 'add-role-permission'
			},
			{
				path: '/admin/manage-users',
				title: 'Manage User',
				permission: 'backend-user-list,update-backend-user,view-backend-user',
				parent: 'manage_acl',
			},
			{
				path: '/admin/manage-users/add',
				title: 'Add User',
				permission: 'add-backend-user',
				parent: 'manage_acl',
			},
		],
	},
	{
		title: `Convert Case Type`,
		path: '/portfolio/change-clm-type',
		id: 'convertclmtype',
		permission: 'option1to2',
		sidebarIcon: (
			<i
				className='item-icon material-icons-round fa fa-retweet  mt-1'
				aria-hidden='true'
			></i>
		),
	},
];


